export default __webpack_public_path__ + "static/media/image5.ef9bda8f.svg";